import React, { Component } from "react";

import RectangleLoader from "common-components/RectangleLoader";
import FallbackUI from "../Layout/MainContent/FallbackUI/FallbackUI";

const AEMContentFromHTML = WrappedComponent => {
  return class extends Component {
    state = {
      loadingAEMContent: true,
      errorFindingAEMContent: false,
      pageContent: {}
    };

    componentDidMount() {
      const pageContent =
        window.landingPageJsonData &&
          typeof window.landingPageJsonData !== "object"
          ? JSON.parse(window.landingPageJsonData)
          : window.landingPageJsonData;
      
     

      if (pageContent) {
        this.setState({ loadingAEMContent: false, pageContent });
      } else {
        this.setState({ loadingAEMContent: false, errorFindingAEMContent: true });
      }
    }

    render() {
      if (this.state.loadingAEMContent) {
        return <RectangleLoader />;
      }
      if (this.state.errorFindingAEMContent) {
        return <FallbackUI />;
      }
      return <WrappedComponent {...this.props} {...this.state} />;
    }
  };
};

export default AEMContentFromHTML;
